import { useRef, useState } from "react";

const useDragMove = ({
  object,
  onSelect,
  updateObjectPosition,
  objects = [],
  selectedGroupId = null,
  disabled = false,
}) => {
  const draggingRef = useRef(false);
  const startPositionsRef = useRef({});
  const [isDragging, setIsDragging] = useState(false);

  const handleMouseDown = (e) => {
    e.stopPropagation();

    onSelect?.(e);

    if (disabled) return;

    draggingRef.current = true;
    setIsDragging(true);

    const startMouseX = e.clientX;
    const startMouseY = e.clientY;

    startPositionsRef.current = {};

    if (selectedGroupId && object.group === selectedGroupId) {
      const groupObjects = (objects || []).filter(
        (obj) => obj.group === selectedGroupId
      );

      groupObjects.forEach((obj) => {
        startPositionsRef.current[obj.id] = {
          x: obj.x,
          y: obj.y,
        };
      });
    } else {
      startPositionsRef.current[object.id] = {
        x: object.x,
        y: object.y,
      };
    }

    const handleMouseMove = (moveEvent) => {
      if (!draggingRef.current) return;

      const deltaX = moveEvent.clientX - startMouseX;
      const deltaY = moveEvent.clientY - startMouseY;

      const movingGroup =
        selectedGroupId &&
        object.group === selectedGroupId &&
        Object.keys(startPositionsRef.current).length > 1;

      if (movingGroup) {
        Object.entries(startPositionsRef.current).forEach(([id, startPos]) => {
          updateObjectPosition?.(
            id,
            startPos.x + deltaX,
            startPos.y + deltaY
          );
        });
        return;
      }

      const startPos = startPositionsRef.current[object.id];
      if (!startPos) return;

      updateObjectPosition?.(
        object.id,
        startPos.x + deltaX,
        startPos.y + deltaY
      );
    };

    const handleMouseUp = () => {
      draggingRef.current = false;
      setIsDragging(false);
      startPositionsRef.current = {};
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
  };

  return {
    isDragging,
    handleMouseDown,
  };
};

export default useDragMove;